<script>
  import IntersectionObserver from "svelte-intersection-observer";
  import Carousel from "./ShareWithWorld/Carousel.svelte";
  import CityCouncilSection from "./Find/CityCouncilSection.svelte";
  import ContactSection from "./Contact/ContactSection.svelte";
  import Emoji from "@helpers/Emoji.svelte";
  import Step from "./Step.svelte";

  let element;
  export let intersecting = false;

  import { selectedDistrict } from "@stores/userData.js";
</script>

<IntersectionObserver {element} bind:intersecting>
  <section bind:this={element} id="share">
    <div class="prose">
      <h1 class="section-title accented">
        <span class="emoji-follows" data-emoji="📢"
          ><Emoji emoji="megaphone" styles="left: -35.5%; top: -90%;" />Let's
        </span> speak up!
      </h1>
      <h2 class="section-subtitle bigger centered">
        In June 2022, our City Council Members will be voting on the budget for
        Fiscal Year 2023.
      </h2>
      <h2 class="section-subtitle">
        City Council Members are our neighbors, living in the District they
        represent. We elect them to represent us, so let's make sure they hear
        what you prioritized for the 2023 budget cycle!
      </h2>
      <h2 class="section-subtitle">
        Below, you can 1. locate your City Council member, 2. notify them of
        your values, and 3. share your budget with the world.
      </h2>
    </div>

    <Step overline="Step 1." title="Find your City Council member:" step={1}>
      <CityCouncilSection />
    </Step>

    <Step
      overline="Step 2."
      title="Share your preferences with your {$selectedDistrict
        ? 'City Council member:'
        : 'network:'}"
      step={2}
    >
      <ContactSection />
    </Step>

    <Step
      overline="Step 3."
      title="Share your preferences with the world!"
      step={3}
    >
      <Carousel />
      <div class="prose final">
        <p class="section-subtitle">
          <!-- FIXME -->
          The work doesn't stop here. You can
          <a
            href="https://mokshadata.notion.site/FY23-Budget-Engagement-Resources-5749620c88c845f3acb196113420d230"
            target="_blank"
            rel="noopener noreferrer"
            >participate by public comment at the City of Houston budget
            meetings</a
          >!
        </p>
      </div>
    </Step>
  </section>
</IntersectionObserver>

<style>
  section {
    text-align: left;
    padding: 5rem 1rem;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    place-items: flex-start;
    border: 1px solid rgba(var(--text-color-rgb), 0.25);
    width: 100%;
    overflow-x: hidden;
  }

  .section-title.accented {
    color: var(--accent-color);
  }

  .section-subtitle {
    font-size: 1.5rem;
    font-weight: 300;
    line-height: 1.25;
    color: rgba(var(--text-color-rgb), 0.7);
    margin-top: 1rem;
    max-width: 668px;
  }

  .bigger {
    color: rgba(0, 0, 0, 0.9);
    font-weight: 400;
    line-height: 1.35;
    font-size: 1.65rem;
  }

  .final {
    margin-top: 4rem;
    text-align: center;
  }

  .emoji-follows:before {
    top: -4rem;
    left: 2.25rem;
  }

  @media screen and (max-width: 568px) {
    .section-subtitle {
      font-size: 1.35rem;
    }
  }
</style>
